/** @format */
import { Context, createContext } from 'react';

import { MarketCode } from '@toucan/client/global/market';
import { Model } from '@toucan/client/global/model';
import { SavedProduct } from '@toucan/client/global/product';

export type UserContextProps = {
    geolocatedMarket?: MarketCode;
    isSavedProductsLoading: boolean;
    isSavedModelsLoading: boolean;
    getSavedProducts: () => void;
    isSavedProduct: (id: number | undefined) => boolean;
    addSavedProduct: (id: number) => void;
    removeSavedProduct: (id: number) => void;
    savedProducts: SavedProduct[];
    isSavedModel: (id: number) => boolean;
    getSavedModels: () => void;
    addSavedModel: (id: number) => void;
    removeSavedModel: (id: number) => void;
    savedModels: Model[];
};

export const UserContext: Context<UserContextProps> = createContext(
    {} as UserContextProps
);

UserContext.displayName = 'UserContext';
